import { getDateFormat } from 'helpers/dates'
import React from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import RemoveIcon from '@material-ui/icons/Remove'
import moment from 'moment'
import ListFromTable from 'components/common/ListFromTable'
import {
  fetchSiteTable,
  siteDelete,
  clearSiteTable,
} from 'reducers/site/reducer'
import ActionCollection from 'types/table/ActionCollection'
import Action from 'types/table/Action'
import UrlHelper from 'helpers/url'
import * as ROUTE from 'constants/appRouting'
import ColumnCollection from 'types/table/ColumnCollection'
import Column from 'types/table/Column'
import ActiveColumn from 'types/table/ActiveColumn'
import Sort from 'lib/psfs/Sort'
import RoleHelper from 'helpers/role'
import messages from './translate'

class SiteList extends ListFromTable {
  constructor(props) {
    super(props)
    this.getTableData = props.fetchSiteTable
    this.deleteEntity = props.siteDelete
    this.clearReducerState = props.clearSiteTable
    this.asyncData = true
    this.loadingData = true
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    this.loadingData = nextProps.loader

    if (nextProps.licenseeId !== this.props.licenseeId) {
      this.reloadTableData(ROUTE.SITE_LIST)

      return false
    }

    return super.shouldComponentUpdate(nextProps, nextState, nextContext)
  }

  getTableProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.siteList),
      showFilterBar: true,
      sorting: true,
      paging: true,
      searching: true,
      creating: true,
    }
  }

  getConfirmDialogProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.deleteSite),
      message: formatMessage(messages.deleteSiteMessage),
    }
  }

  getCreateButton() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.createSite),
      link: ROUTE.SITE_CREATE,
    }
  }

  getColumns() {
    const {
      intl: { formatMessage },
      roleLevel,
      licensee: { usaDateFormat },
    } = this.props
    const columns = new ColumnCollection()
    const dateDisplay = getDateFormat(usaDateFormat)

    columns.add(new Column('id', 'ID', { sorting: true }))
    columns.add(
      new Column('name', formatMessage(messages.name), {
        sorting: true,
        defaultSort: true,
        defaultSortOrder: Sort.ASC,
      }),
    )
    columns.add(new Column('siep', formatMessage(messages.seip)))

    if (roleLevel >= RoleHelper.ROLE_ADMIN_LEVEL) {
      columns.add(
        new Column('type', formatMessage(messages.siteType), {
          sorting: true,
          render: ({ type }) =>
            type ? type.type : <RemoveIcon color="action" />,
        }),
      )
      columns.add(
        new ActiveColumn('active', formatMessage(messages.active), {
          sorting: true,
        }),
      )
    }
    columns.add(
      new ActiveColumn('visibleInUi', formatMessage(messages.visibleInUi), {
        sorting: true,
      }),
    )
    columns.add(
      new Column('dateUpdated', formatMessage(messages.dateUpdated), {
        sorting: true,
        render: row => moment(row.dateUpdated).format(dateDisplay),
      }),
    )

    return columns
  }

  getActions() {
    const {
      roleLevel,
      history,
      intl: { formatMessage },
    } = this.props
    const actions = new ActionCollection()

    if (roleLevel >= RoleHelper.ROLE_ADMIN_LEVEL) {
      actions.add(
        new Action('edit', formatMessage(messages.editSite), row => {
          history.push(UrlHelper.create(ROUTE.SITE_EDIT, { id: row.id }))
        }),
      )
      actions.add(
        new Action('delete', formatMessage(messages.deleteSite), row => {
          this.onOpenConfirmDialog({ entityId: row.id, psfs: this.psfs })
        }),
      )
    }

    return actions
  }
}

export default connect(
  state => ({
    loader: state.getIn(['site', 'isLoadTable']),
    tableData: state.getIn(['site', 'tableData']),
    licenseeId: state.getIn(['profile', 'licenseeId']),
    roleLevel: state.getIn(['profile', 'roleLevel']),
    licensee: state.getIn(['profile', 'profile', 'licensee']),
  }),
  {
    fetchSiteTable,
    clearSiteTable,
    siteDelete,
  },
)(injectIntl(SiteList))
